import React from "react";
import InvestorPropertyDetails from "../../../stories/investor/investor-property-details";
// import styles from "../login/index.module.scss";
// import OtpVerificationC from "../../../stories/investor/opt-verification";

export default function InvestorDetails() {
  return (
    <>
      <InvestorPropertyDetails />
    </>
  );
}
